import type { ShapeProps } from "./index";
import { generateRoundedPath } from "./utils";

export function Triangle({ width, height, ...svgAttributes }: ShapeProps) {
  return (
    <path
      d={generateRoundedPath(
        [
          [0, height],
          [width / 2, 0],
          [width, height],
        ],
        6,
      )}
      {...svgAttributes}
    />
  );
}
